// extracted by mini-css-extract-plugin
export default {"loginToAccess":"SignInSubTitle_loginToAccess__xNOK-","welcomeToQuickAsyst":"SignInSubTitle_welcomeToQuickAsyst__eB6bV","welcomeText":"SignInSubTitle_welcomeText__iBJ3o"};